import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import {
  DTOputCommentLoogisticsService,
  DTOputLogisticServicePaymentLink,
  DTOupdateLogisticServiceStatus,
  IInProcessStatusDto,
  INewSerialAndSKU,
  IReportLogisticServiceReason,
  IUpdateLogisticServiceAddress,
  IactiveLsStatusDto,
  IlogisticServiceDetails,
  TLogisticsDocument,
  IReportingOptions,
  IReportBody,
  IReportLogisticServiceProblemBody,
  IlogisticServiceTrelloCardData,
  IUpdateInvoiceNumbeInALogisticsService,
  IUpdateInvoiceData,
  IUserId,
  IupdateLsPurchaseOrder,
  IUpdateManualQuotation,
  IfetchReplacementTools,
  IreplaceLsTools,
  IProductReference,
  IsearchReferenceProducts,
  IUpdateDeliveryStatus,
  IAddExternalProductsToLogisticService,
  IAddExternalProductsToLogisticServiceResponse
} from '../types/services';
import { apiGet, apiGetWithCancelation, apiPatch, apiPost, apiPostFile, apiPut } from './api';
import { IlogisticServiceListingCardData } from '../views/services/components/LogisticServiceListingCard/LogisticServiceListingCard';
import { apiGetWithCancelationSL } from './logisticServicesApi';
import { IToolData } from '../types/products';
import {
  IInvoiceLogisticServiceRecord,
  IInvoiceRecord
} from 'components/InvoiceSectionOfBillingTab/InvoiceSectionOfBillingTab.types';

const { REACT_APP_SUBSCRIPTION, REACT_APP_CATALOG } = process.env;

const getLogisticServicesTrelloDataByState = async (
  listingEndpoint: string[]
): Promise<IlogisticServiceTrelloCardData[]> => {
  const endpointURL = listingEndpoint[0];
  const logisticStatus = listingEndpoint[1];
  return apiGetWithCancelationSL<AxiosRequestConfig, IlogisticServiceTrelloCardData[]>(
    `${REACT_APP_SUBSCRIPTION}${endpointURL}`,
    logisticStatus
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

const getLogisticServicesListingData = async (listingEndpoint: string): Promise<IlogisticServiceListingCardData[]> => {
  return apiGetWithCancelation<AxiosRequestConfig, IlogisticServiceListingCardData[]>(
    `${REACT_APP_SUBSCRIPTION}${listingEndpoint}`
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateStatusService = async (
  logisticServiceId?: number | string,
  body?: DTOupdateLogisticServiceStatus,
  paymentFile?: File,
  invoiceFile?: File
) => {
  const formData = new FormData();
  const bodyJson = JSON.stringify(body);
  body && formData.append('body', bodyJson);
  paymentFile && formData.append('payment', paymentFile);
  invoiceFile && formData.append('invoice', invoiceFile);
  return apiPut<AxiosRequestConfig, FormData>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/set-status/${logisticServiceId}`,
    formData
  )
    .then(resp => {
      const updateResponse: string = resp;
      return updateResponse;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

const editActiveServiceInformation = async (logisticServiceId: number | string, body: IactiveLsStatusDto) => {
  return apiPut<AxiosRequestConfig, IactiveLsStatusDto>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/edit/${logisticServiceId}`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const createLogisticsServiceComment = async (body: DTOputCommentLoogisticsService) => {
  const formData = new FormData();
  const bodyJson = JSON.stringify(body);
  formData.append('body', bodyJson);
  body?.commentImage && formData.append('file', body.commentImage);
  return apiPost<AxiosRequestConfig, FormData>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/comment/backoffice`,
    formData
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const uploadDocumentLogisticsService = async (
  logisticServiceId: number,
  typeOfDocument: TLogisticsDocument,
  document: File,
  countryId: number
) => {
  const formData = new FormData();
  formData.append('file', document);
  return apiPut<AxiosRequestConfig, FormData>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/backoffice/save-document/${logisticServiceId}/${typeOfDocument}${
      countryId ? `?countryId=${countryId}` : ''
    }`,
    formData
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const putLogisticServicePaymentLink = async (
  logisticServiceId: number | string,
  body: DTOputLogisticServicePaymentLink
) => {
  return apiPut<AxiosRequestConfig, DTOputLogisticServicePaymentLink>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/payment-link/${logisticServiceId}`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const getLogisticServiceDetailsById = async (logisticServiceId: string | number) => {
  return apiGet<AxiosRequestConfig, IlogisticServiceDetails>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/backoffice/detail/${logisticServiceId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const getLogisticServiceSummaryUrl = async (logisticServiceId: string | number) => {
  return apiGet<AxiosRequestConfig, { url: string }>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/resume/pdf?logisticServiceId=${logisticServiceId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const getLogisticServiceReportReasons = async () => {
  return apiGet<AxiosRequestConfig, IReportLogisticServiceReason[]>(`${REACT_APP_SUBSCRIPTION}/report/reasons`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

/**
 * Actualiza el serial y SKU de un producto
 * @param productId - ID del producto
 * @param bodyUpdate - Datos a actualizar (serial y SKU)
 * @param logisticServiceId - ID del servicio logístico (opcional)
 */
const updateDataSerialAndSKU = async (
  productId: number,
  bodyUpdate: INewSerialAndSKU,
  logisticServiceId?: number | null
) => {
  const queryParam = logisticServiceId ? `?logisticServiceId=${logisticServiceId}` : '';
  return apiPut<AxiosRequestConfig, INewSerialAndSKU>(
    `${REACT_APP_SUBSCRIPTION}/product/edit/product-details/${productId}${queryParam}`,
    bodyUpdate
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const downLoadStorageInventory = async () => {
  return apiGet<AxiosRequestConfig, IlogisticServiceDetails>(
    `${REACT_APP_SUBSCRIPTION}/product/download/storage-inventory`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateProviderLS = async (providerBody: IInProcessStatusDto, logisticServiceId: number) => {
  return apiPut<AxiosRequestConfig, IInProcessStatusDto>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/edit/${logisticServiceId}`,
    providerBody
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const reportAddressIssue = async (logisticServiceId: number, location: string) => {
  return apiPut<AxiosRequestConfig, string>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/report-address-issue/${logisticServiceId}/${location}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const optionsReportAddressIssue = async (reportBody: IReportBody) => {
  return apiPut<AxiosRequestConfig, IReportBody>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/report-address-issue`,
    reportBody
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};
const postReportLogisticServiceProblem = async (reportLSProblemBody: IReportLogisticServiceProblemBody) => {
  return apiPost<AxiosRequestConfig, IReportLogisticServiceProblemBody>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/report/create`,
    reportLSProblemBody
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const checkAddressChanged = async (logisticServiceId: number, location: string) => {
  return apiPut<AxiosRequestConfig, string>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/backoffice/address-change-viewed/${logisticServiceId}/${location}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateLogisticServiceAddress = async (
  logisticServiceId: number | string,
  location: string,
  body: IUpdateLogisticServiceAddress
) => {
  return apiPut<AxiosRequestConfig, IUpdateLogisticServiceAddress>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/backoffice/edit-address/${logisticServiceId}/${location}`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error));
};

const getReportingOptionsLogisticsServices = async () => {
  return apiGet<AxiosRequestConfig, IReportingOptions[]>(`${REACT_APP_SUBSCRIPTION}/address-wrong-field`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateChargeZero = async (logisticsServiceId: number, bodyUserId: IUserId) => {
  return apiPut(`${REACT_APP_SUBSCRIPTION}/logistic-service/add-payment-zero/${logisticsServiceId}`, bodyUserId)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateInvoiceNumbeInALogisticsService = async (updateData: IUpdateInvoiceNumbeInALogisticsService) => {
  return apiPut<AxiosRequestConfig, IUpdateInvoiceData>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/invoice/${updateData.logisticServiceId}`,
    updateData.invoiceNumberDetails
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateLsPurchaseOrder = async (body: IupdateLsPurchaseOrder) => {
  return apiPut<AxiosRequestConfig, IupdateLsPurchaseOrder>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/purchase-order`,
    body
  );
};

const updateManualQuotation = async (body: IUpdateManualQuotation) => {
  return apiPatch<AxiosRequestConfig, IUpdateManualQuotation>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/update-logistic-service-price`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const fetchReplacementTools = async (body: IfetchReplacementTools): Promise<IToolData[]> => {
  return apiPost<AxiosRequestConfig, IfetchReplacementTools>(`${REACT_APP_SUBSCRIPTION}/product/find-available`, body)
    .then(response => Promise.resolve(response?.data || response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const replaceLsTools = async (body: IreplaceLsTools) => {
  return apiPost<AxiosRequestConfig, IreplaceLsTools>(`${REACT_APP_SUBSCRIPTION}/replace-ls-product`, body)
    .then(response => Promise.resolve(response?.data || response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const uploadDocumentPurchaseOrder = async (formData: FormData): Promise<string> => {
  return apiPostFile<AxiosRequestConfig, string>(`${REACT_APP_SUBSCRIPTION}/document`, formData)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateNewCreditDate = async (logisticServiceId: number, date: string, sendNotificationEmail: boolean = true) => {
  const queryParam = sendNotificationEmail ? '' : '?sendNotificationEmail=false';
  return apiPut<AxiosRequestConfig>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/payment-agreement-date/${logisticServiceId}/${date}${queryParam}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const searchReferenceProducts = async ({
  query,
  omitCanBeLoaded
}: IsearchReferenceProducts): Promise<IProductReference[]> => {
  return apiGet<AxiosRequestConfig, IProductReference[]>(
    `${REACT_APP_CATALOG}catalog/product/search${query ? `?q=${query}&omitCanBeLoaded=${omitCanBeLoaded}` : ''}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};
const addExternalProductsToLogisticService = async (
  body: IAddExternalProductsToLogisticService
): Promise<IAddExternalProductsToLogisticServiceResponse> => {
  return apiPost<
    AxiosRequestConfig,
    IAddExternalProductsToLogisticService,
    AxiosResponse<IAddExternalProductsToLogisticServiceResponse>
  >(`${REACT_APP_SUBSCRIPTION}/product-management/logistic-service/add-tools`, body)
    .then((response: AxiosResponse<IAddExternalProductsToLogisticServiceResponse>) =>
      Promise.resolve(response?.data || response)
    )
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateDeliveryStatus = async (body: IUpdateDeliveryStatus): Promise<string> => {
  return apiPut<AxiosRequestConfig, IUpdateDeliveryStatus>(
    `${REACT_APP_SUBSCRIPTION}/product-management/logistic-service/update-tools-delivery-status`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const createLogisticServiceInvoiceRecord = async (body: IInvoiceLogisticServiceRecord) => {
  return apiPost<AxiosRequestConfig, IInvoiceRecord, { data: IInvoiceRecord }>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/invoice-record`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateLogisticServiceInvoiceRecord = async (
  invoiceRecordId: number,
  body: IInvoiceLogisticServiceRecord
): Promise<IInvoiceRecord> => {
  return apiPut<AxiosRequestConfig, IInvoiceRecord>(
    `${REACT_APP_SUBSCRIPTION}/logistic-service/invoice-record/${invoiceRecordId}`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};
export {
  updateStatusService,
  editActiveServiceInformation,
  createLogisticsServiceComment,
  uploadDocumentLogisticsService,
  putLogisticServicePaymentLink,
  getLogisticServiceDetailsById,
  getLogisticServiceSummaryUrl,
  updateDataSerialAndSKU,
  downLoadStorageInventory,
  updateProviderLS,
  getLogisticServicesListingData,
  reportAddressIssue,
  checkAddressChanged,
  updateLogisticServiceAddress,
  getLogisticServiceReportReasons,
  postReportLogisticServiceProblem,
  getReportingOptionsLogisticsServices,
  optionsReportAddressIssue,
  getLogisticServicesTrelloDataByState,
  updateChargeZero,
  updateInvoiceNumbeInALogisticsService,
  updateLsPurchaseOrder,
  updateManualQuotation,
  fetchReplacementTools,
  replaceLsTools,
  uploadDocumentPurchaseOrder,
  updateNewCreditDate,
  searchReferenceProducts,
  addExternalProductsToLogisticService,
  updateDeliveryStatus,
  createLogisticServiceInvoiceRecord,
  updateLogisticServiceInvoiceRecord
};
